export const getConfiguration = () => {
  const country = window.tc_vars.env_country;
  return Object.assign({}, defaultConfiguration, countryConfiguration[country]);
};

// Common for all Countries
const defaultConfiguration = {
  type: 'WOOSMAP',
  inputDebounce: 200,
  inputMinLength: 3,
  country: window.tc_vars.env_country.toLowerCase(),
};

// Country config overrides default
const countryConfiguration = {
  CN: {
    type: 'BAIDU',
    inputDebounce: 0,
    inputMinLength: 1,
  },
};



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/ac-configuration.js